import { stringToReadableDate } from './formatting';

export const getBrandReportHeaderLabel = ({ groupingMethod, week, month, quarter }) => {
  if (!groupingMethod) {
    if (week) return `${stringToReadableDate({ week }).shortened_month} ${stringToReadableDate({ week }).day_of_month}`;
    else if (month) return stringToReadableDate({ month }).shortened_month;
    else if (quarter) return `Q${quarter}`;
    else return 'N/A';
  }

  switch (groupingMethod) {
    case 'week':
      return `${stringToReadableDate({ week }).shortened_month} ${stringToReadableDate({ week }).day_of_month}`;
    case 'month':
      return stringToReadableDate({ month }).shortened_month;
    case 'quarter':
      return `Q${quarter}`;
    default:
      return quarter ? `Q${quarter}` : stringToReadableDate({ month }).shortened_month;
  }
};
